import { type BentoSatellite, BentoSection } from './bento-section'
import { PageShot } from './mockups/base'
import { CalendarioMockup, TarefasQuadroMockup, VisitasAgendaMockup } from './mockups/modules'
import { ProjetosQuadroScreen } from './mockups/screens'

/*
 * O trabalho do escritório: o quadro de projetos por etapa de execução como
 * âncora, e as três telas que o dia a dia usa — tarefas, agenda e visitas.
 */

const SATELLITES: BentoSatellite[] = [
  {
    body: 'Quadro, lista ou Gantt. Cada tarefa carrega a fase da obra, a prioridade, o intervalo de datas e quem responde por ela.',
    title: 'Tarefas em sprints semanais',
    visual: <TarefasQuadroMockup />,
  },
  {
    body: 'Visitas, entregas e o fechamento do sprint na mesma semana, do jeito que a agenda do escritório realmente é.',
    title: 'A semana inteira em uma tela',
    visual: <CalendarioMockup />,
  },
  {
    body: 'A próxima visita já com checklist e participantes, e o histórico de tudo o que foi medido, fotografado e apontado em cada obra.',
    title: 'Visitas técnicas com histórico',
    visual: <VisitasAgendaMockup />,
  },
]

export const TrabalhoBento = () => (
  <BentoSection
    accent="#a87a18"
    anchor={
      <PageShot className="shadow-[0_24px_60px_-26px_rgba(60,40,20,0.28)]" height={440}>
        <ProjetosQuadroScreen />
      </PageShot>
    }
    background="bg-[#fbf6ec]"
    cardBg="bg-white"
    cardBorder="border-[#ece6d8]"
    heading="Projetos, tarefas, sprints e visitas no mesmo lugar"
    hrefLabel="Ver tudo do trabalho"
    hrefTo="/recursos/trabalho"
    intro="Cada projeto anda pelas etapas de execução do escritório e carrega suas tarefas, sua agenda e suas visitas à obra."
    layout="showcase"
    satellites={SATELLITES}
  />
)
